//This is the final used code
import { useUI } from "../context/UIContext";
import { useProjectGantt } from "../hooks/gantt/useProjectGantt";
import { GanttChart } from "./gantt/GanttChart";

export default function ProjectGantt() {
  const { selectedProjectId,selectedProjectName, isRestored, ganttAsOnDate } = useUI();

  const { data, isLoading, error } = useProjectGantt(
    selectedProjectId ?? 0,
    ganttAsOnDate ?? "",
    {
      enabled: isRestored && !!selectedProjectId && !!ganttAsOnDate 
    }
  );

  if (!isRestored) return <div>Loading UI state…</div>;
  if (!selectedProjectId) return <div>No project selected</div>;
  if (!ganttAsOnDate) return <div>Please select a date to view the Gantt chart.</div>;
  if (isLoading) return <div>Loading Gantt…</div>;
  if (error || !data) return <div>Failed to load Gantt</div>;

  return (
    <div className="w-full h-full flex flex-col min-h-0">
      <GanttChart 
        items={data} 
       // projectName={selectedProjectName}
        projectName={selectedProjectName ?? "Project"} // ✅ Safe
        asOnDate={ganttAsOnDate}
      />
    </div>
  );
}







